import { CanDeactivateFn } from '@angular/router';

/** Implement this on any page that wants a confirm-before-leaving prompt
 *  when the user tries to navigate away (back button, browser back,
 *  another nav link) while they have unsaved work. */
export interface CanComponentDeactivate {
  canDeactivate: () => boolean | Promise<boolean>;
}

export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => {
  return component.canDeactivate ? component.canDeactivate() : true;
};
